import {useMutation, UseMutationResult} from '@tanstack/react-query';
import {useLocale} from 'state/locale';
import Api from 'types/api';
import {DocumentType} from 'types/documents';
import {toSnakeCase} from 'utils/object';
import {request} from 'utils/request-axios';

export type TRNDEditErrorResponse = Api.Response.Failure<{
    [K in DocumentType]: boolean;
}>;

export type TRNDEditFormFields = {
    clientTrnEnabled: {[K in DocumentType]: boolean};
    partnerTrnEnabled: {[K in DocumentType]: boolean};
};

export type TRNDEditSuccessResponse = Api.Response.Template.SuccessBasicMessage;

export const usePostTRNDEdit = (): UseMutationResult<
    TRNDEditSuccessResponse,
    Error,
    {formData: TRNDEditFormFields; mid: string}
> => {
    const locale = useLocale();

    return useMutation({
        mutationFn: ({formData, mid}) =>
            request({
                formData: toSnakeCase(formData),
                locale,
                method: 'POST',
                url: `/api/partner/${mid}/document/trn-display-settings/update/`,
            }),
    });
};
